import { useMemo } from 'react';

/**
 * 배열을 Set으로 변환하여 기존 값 존재 여부를 빠르게 확인할 수 있도록 합니다.
 * EditableTreeSelect의 existingValues prop에 전달하여 isExisting 스타일을 적용할 때 사용합니다.
 *
 * @example
 * ```tsx
 * const tagFQNs = ['tag1', 'tag2', 'tag3'];
 * const existingTagFQNs = useExistingValues(tagFQNs);
 * // existingTagFQNs.has('tag1') => true
 * ```
 */
export const useExistingValues = <T extends string>(values: T[]): Set<T> => {
  return useMemo(() => new Set(values), [values]);
};
